import { UserKeys } from '@webapp/platform/iam/entities/enums/UserKeys'

const userKey = 'user'

const list = [userKey, UserKeys.LIST]

export const userKeys = {
  list,
  unfilteredCount: (isActive?: boolean) => [
    ...list,
    isActive,
    'unfiltered-count',
  ],
  details: [userKey, UserKeys.DETAIL],
  purchasePriceLimit: [userKey, UserKeys.PURCHASE_PRICE_LIMIT],
  getCounts: [userKey, UserKeys.COUNTS],
}
